// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_description = /** @type {(inputs: {}) => string} */ () => {
	return `Description`
};

const el_description = /** @type {(inputs: {}) => string} */ () => {
	return `Περιγραφή`
};

const ru_description = /** @type {(inputs: {}) => string} */ () => {
	return `Описание`
};

const he_description = /** @type {(inputs: {}) => string} */ () => {
	return `תיאור`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("description", locale)
	if (locale === "en") return en_description(inputs)
	if (locale === "el") return el_description(inputs)
	if (locale === "ru") return ru_description(inputs)
	if (locale === "he") return he_description(inputs)
	return "description"
};